import cx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import {
  PromotionDetailsModal,
} from '@/app/_components/page_content/new-car-promo/promotion-details-modal';
import { createTimestampUid } from '@/utils/id';
import { joinSgcmMedia, joinSgcmMsSite } from '@/utils/url/join/public';

import styles from './styles.module.scss';
import type { Component } from './types';

export const SponsoredContent: Component = ({
  promotions,
  modelId,
  className,
}) => {
  const promo = promotions
    .find(
      promotion => promotion.promoType === 'tactical_ads'
      && promotion.competitorCars?.find(id => id === modelId.toString()),
    );

  const [
    promotionDetailsModalKey,
    setPromotionDetailsModalKey,
  ] = useState(createTimestampUid);

  const [
    isPromotionDetailsModalOpen,
    setIsPromotionDetailsModalOpen,
  ] = useState(false);
  const isCompetitorCar = promo?.competitorCars?.find(
    competitorCarId => competitorCarId === modelId.toString(),
  );

  return promo && (
    <div className={cx(
      styles.containerRoot,
      className,
    )}>
      <div className={styles.containerContent}>
        <div className={styles.testSponsored}>Sponsored Content</div>
        <div className={styles.containerMobileContent}>
          <Link
            className={styles.containerCard}
            href={joinSgcmMsSite(`/new-cars/info/${promo.carId}/${promo.slug}/promo${isCompetitorCar ? `?competitor_car=${promo.competitorCars?.join(',')}` : ''}#${promo.id}`)}>
            <Image
              alt={promo.description}
              className={styles.image}
              height={60}
              layout="intrinsic"
              src={`https://i.i-sgcm.com/new_cars/promos/${promo.dealer.id}/${promo.id}_l.jpg`}
              width={300} />
          </Link>
        </div>
        <div className={styles.containerDesktopContent}>
          <Image
            alt={promo.description}
            className={styles.image}
            height={60}
            layout="intrinsic"
            src={`${joinSgcmMedia(`/public/new-cars/promos/${promo.dealer.id}/tactical-ads-${promo.id}-d-728x90.jpg`)}`}
            width={728}
            onClick={() => {
              setIsPromotionDetailsModalOpen(true);
            }} />
          <PromotionDetailsModal
            key={promotionDetailsModalKey}
            isOpen={isPromotionDetailsModalOpen}
            promotion={promo}
            onClose={() => {
              setIsPromotionDetailsModalOpen(false);
              window.history.pushState(null, '', ' ');
            }}
            onExit={() => {
              setPromotionDetailsModalKey(createTimestampUid());
            }} />
        </div>
      </div>
    </div>
  );
};
